import script from "./AskSlotModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AskSlotModal.vue?vue&type=script&setup=true&lang=ts"

import "./AskSlotModal.vue?vue&type=style&index=0&id=1567330c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1567330c"]])

export default __exports__